
import { Vue, Component, Ref, Model, Watch } from 'vue-property-decorator';
import VehicleModule from '@/components/carModule/VehicleModule.vue';

@Component({
  components: {
    VehicleModule,
  },
})
export default class HtmlField extends Vue {
  name = 'NameField';
  val = '';

  @Ref()
  vehicleModule!: VehicleModule;

  init() {
    this.vehicleModule.init();
  }

  @Model('change', {
    type: String,
  })
  value!: string;

  @Watch('val')
  watchVal() {
    this.$emit('update', this.val);
  }

  @Watch('value')
  watchValue() {
    if (this.value) {
      this.val = `${this.value}`;
    } else {
      this.val = '';
    }
  }

  mounted() {
    this.watchValue();
  }
}
